const YEAR_4_TEACHER_ACTION_TYPE = {
  GET_YEAR_4_TEACHERS: 'GET_YEAR_4_TEACHERS',
  GET_YEAR_4_TEACHER: 'GET_YEAR_4_TEACHER',
  CREATE_YEAR_4_TEACHER: 'CREATE_YEAR_4_TEACHER',
  UPDATE_YEAR_4_TEACHER: 'UPDATE_YEAR_4_TEACHER',
  DELETE_YEAR_4_TEACHER: 'DELETE_YEAR_4_TEACHER',
  CREATE_YEAR_4_TEACHER_NOTE: 'CREATE_YEAR_4_TEACHER_NOTE',
  UPDATE_YEAR_4_TEACHER_NOTE: 'UPDATE_YEAR_4_TEACHER_NOTE',
  DELETE_YEAR_4_TEACHER_NOTE: 'DELETE_YEAR_4_TEACHER_NOTE'
}
export default YEAR_4_TEACHER_ACTION_TYPE
